export default [
  {
    path: '/main/causeofmaintance',
    meta: {
      tag: 'list_causeofmaintance',
      name: 'Causas de Manutenção',
      breadcrumb: 'Causas de Manutenção'
    },
    component: () => import(/* webpackChunkName: "causeofmaintance-list" */ '@/views/main/settings/test-registers/causeofmaintance/Index.vue'),
    children: [
      {
        path: '',
        name: 'listcauseofmaintance',
        meta: {
          tag: 'list_causeofmaintance',
          menu: 'settings',
          name: 'Causas de Manutenção'
        },
        component: () => import(/* webpackChunkName: "causeofmaintance-list" */ '@/views/main/settings/test-registers/causeofmaintance/List.vue')
      },
      {
        path: '/main/causeofmaintance/add',
        name: 'addcauseofmaintance',
        meta: {
          tag: 'add_causeofmaintance',
          menu: 'settings',
          name: 'Adicionar | Causa de Manutenção',
          breadcrumb: 'Adicionar Causa de Manutenção'
        },
        component: () => import(/* webpackChunkName: "causeofmaintance-add" */ '@/views/main/settings/test-registers/causeofmaintance/Add.vue')
      },
      {
        path: '/main/causeofmaintance/:id',
        name: 'editcauseofmaintance',
        meta: {
          tag: 'edit_causeofmaintance',
          menu: 'settings',
          name: 'Editar | Causa de Manutenção',
          breadcrumb: 'Editar Causa de Manutenção'
        },
        component: () => import(/* webpackChunkName: "causeofmaintance-edit" */ '@/views/main/settings/test-registers/causeofmaintance/Edit.vue')
      }
    ]
  },
]
